import { ColorScheme } from '../services/color-scheme/color-scheme.models';
import { StateSliceDefaults, StateSliceName } from '../store.models';

export interface UserSettingsStateModel {
    colorScheme: ColorScheme | undefined;
}

export const userSettingsStateDefaults: StateSliceDefaults<UserSettingsStateModel> = Object.freeze({
    sliceName: StateSliceName.USER_SETTINGS,
    defaults: {
        colorScheme: undefined
    }
});
